import * as bootstrap from 'bootstrap'
import Splide from '@splidejs/splide'

///
// Dropdown navigation
///

const myDropdown = document.getElementById('navbarDropdown')

if (myDropdown) {
  myDropdown.addEventListener('show.bs.dropdown', function () {
    document.getElementById('pageHeader').classList.add('open')
  })

  myDropdown.addEventListener('hide.bs.dropdown', function () {
    document.getElementById('pageHeader').classList.remove('open')
  })
}

///
// Offcanvas menu
///

const offcanvasMenu = document.getElementById('offcanvasMenu')
if (offcanvasMenu) {
  const openOffcanvas = () => {
    offcanvasMenu.classList.add('is-open')
    offcanvasMenu.setAttribute('aria-hidden', 'false')
    document.body.classList.add('offcanvas-menu-open')
  }
  const closeOffcanvas = () => {
    offcanvasMenu.classList.remove('is-open')
    offcanvasMenu.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('offcanvas-menu-open')
  }

  document.querySelectorAll('[data-offcanvas-open="#offcanvasMenu"]').forEach((btn) => {
    btn.addEventListener('click', openOffcanvas)
  })
  offcanvasMenu.querySelectorAll('[data-offcanvas-close]').forEach((btn) => {
    btn.addEventListener('click', closeOffcanvas)
  })
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && offcanvasMenu.classList.contains('is-open')) closeOffcanvas()
  })

  offcanvasMenu.querySelectorAll('.offcanvas-menu__submenu-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true'
      btn.setAttribute('aria-expanded', String(!expanded))
    })
  })
}

///
// Program teaser slider
///

const teaserSplides = document.querySelectorAll('.splide-teaser')
if (teaserSplides.length) {
  for (let i = 0; i < teaserSplides.length; i++) {
    let splideElement;
    splideElement = teaserSplides[i]
    const splideDefaultOptions =
      {
        autoplay: false,
        interval: 7000,
        pauseOnHover: false,
        arrows: false,
        perPage: 2,
        perMove: 1,
        gap: '1.5em',
        type: 'slide',
        pagination: true,
        keyboard: false,
        slideFocus: false,
        mediaQuery: 'min',
        breakpoints: {
          576: {
            perPage: 2
          },
          768: {
            perPage: 3
          },
          992: {
            perPage: 4
          },
          1200: {
            perPage: 4
          },
          1400: {
            perPage: 5
          }
        }
      }
    const splide = new Splide(splideElement, splideDefaultOptions)

    splide.mount()
  }
}

///
// Event teaser slider
///

const eventSplides = document.querySelectorAll('.splide-events')
if (eventSplides.length) {
  for (let i = 0; i < eventSplides.length; i++) {
    var splideElement
    splideElement = eventSplides[i]
    const splideDefaultOptions =
      {
        autoplay: false,
        interval: 7000,
        pauseOnHover: false,
        arrows: false,
        perPage: 1,
        perMove: 1,
        gap: '1.5em',
        type: 'slide',
        pagination: true,
        keyboard: false, // Splide listens to key events at the document level and moves ALL carousels when arrow keys are used. Since keyboard and screen reader users use these keys to operate the tabs, this creates a very unusual experience.
        slideFocus: false, // removes tabindex="0" from each slide wrapper, since we only want our links inside each slide to receive focus.
        mediaQuery: 'min',
        breakpoints: {
          576: {
            perPage: 1
          },
          768: {
            perPage: 2
          },
          992: {
            perPage: 2
          },
          1200: {
            perPage: 3
          },
          1400: {
            perPage: 3
          }
        }
      }
    const splide = new Splide(splideElement, splideDefaultOptions)

    splide.mount()
  }
}

///
// Hero banner slider
///

let splide
let previousButton, nextButton
let rotationButton, pauseContainer, resumeContainer

document.addEventListener('DOMContentLoaded', function () {
  previousButton = document.querySelector('.carousel .previous-button')
  nextButton = document.querySelector('.carousel .next-button')

  rotationButton = document.querySelector('.carousel .rotation-button')
  pauseContainer = document.querySelector('.carousel .rotation-button .pause-container')
  resumeContainer = document.querySelector('.carousel .rotation-button .resume-container')

  splide = new Splide('.splide-hero', {
    autoplay: false,
    interval: 5300,
    pauseOnHover: false,
    loop: true,
    arrows: false,
    perPage: 1,
    type: 'slide',
    pagination: true,
    keyboard: false, // Splide listens to key events at the document level and moves ALL carousels when arrow keys are used. Since keyboard and screen reader users use these keys to operate the tabs, this creates a very unusual experience.
    slideFocus: false // removes tabindex="0" from each slide wrapper, since we only want our links inside each slide to receive focus.
  }).mount()

  // To prevent animation issues, let's make every slide visible before a transition happens. Splide will then automatically remove the `.is-visible` class from non-visible slides once the transition is finished.
  splide.on('move', function () {
    const slides = document.querySelectorAll('.splide-hero .splide__slide')

    slides.forEach(function (slide) {
      slide.classList.add('is-visible')
    })
  })

  if (previousButton) {
    previousButton.addEventListener('click', function (e) {
      disableAutoplay()
      splide.go('<')
    })
  }

  if (nextButton) {
    nextButton.addEventListener('click', function (e) {
      disableAutoplay()
      splide.go('>')
    })
  }

  if (rotationButton) {
    rotationButton.addEventListener('click', function (e) {
      toggleAutoplay()
    })
  }

  /**
   Disable or enable built-in Splide Slider autoplay
   */
  function toggleAutoplay () {
    const autoplayEnabled = splide.options.autoplay

    if (autoplayEnabled) {
      disableAutoplay()
    } else {
      enableAutoplay()
    }
  }

  function disableAutoplay () {
    splide.Components.Autoplay.pause()
    splide.options = { autoplay: false }

    if (pauseContainer) pauseContainer.classList.remove('is-visible')
    if (resumeContainer) resumeContainer.classList.add('is-visible')
  }

  function enableAutoplay () {
    splide.Components.Autoplay.play()
    splide.options = { autoplay: true }

    if (pauseContainer) pauseContainer.classList.add('is-visible')
    if (resumeContainer) resumeContainer.classList.remove('is-visible')
  }
})

///
// Gallery slider
///

const gallerySplides = document.querySelectorAll('.splide-gallery')
if (gallerySplides.length) {
  for (let i = 0; i < gallerySplides.length; i++) {

    var splideElement
    splideElement = gallerySplides[i]


    const SliderModalID = splideElement.getAttribute('data-modalid');
    const SliderModalElement = document.querySelectorAll('.splide-modal[data-modalid='+SliderModalID+']');

    const splideDefaultOptions =
      {
        type: 'loop',
        focus: 'center',
        autoplay: false,
        interval: 7000,
        pauseOnHover: false,
        arrows: false,
        perPage: 2,
        perMove: 1,
        gap: '1.5em',
        pagination: true,
        isNavigation: true,
        keyboard: false, // Splide listens to key events at the document level and moves ALL carousels when arrow keys are used. Since keyboard and screen reader users use these keys to operate the tabs, this creates a very unusual experience.
        slideFocus: false, // removes tabindex="0" from each slide wrapper, since we only want our links inside each slide to receive focus.
        mediaQuery: 'min',
        breakpoints: {
          1: {
            perPage: 1,
            padding: '3em',
            height: '15rem',
            autoWidth: true,
          },
          576: {
            perPage: 2,
            padding: '3em',
            autoWidth: true,
            height: '15rem'
          },
          768: {
            perPage: 2,
            height: '15rem',
            autoWidth: true,
          },
          992: {
            perPage: 3,
            autoWidth: true,
            height: '15rem'
          },
          1200: {
            perPage: 1,
            autoWidth: true,
            height: '30rem'
          },
          1400: {
            perPage: 1,
            autoWidth: true,
            height: '30rem'
          }
        }
      }
    const splide = new Splide(splideElement, splideDefaultOptions)

     // Modal

    const splideDefaultOptionsModal =
      {
        type: 'loop',
        focus: 'center',
        autoplay: false,
        interval: 7000,
        pauseOnHover: false,
        arrows: false,
        perPage: 2,
        perMove: 1,
        gap: '1.5em',
        pagination: true,
        isNavigation: true,
        keyboard: false, // Splide listens to key events at the document level and moves ALL carousels when arrow keys are used. Since keyboard and screen reader users use these keys to operate the tabs, this creates a very unusual experience.
        slideFocus: false, // removes tabindex="0" from each slide wrapper, since we only want our links inside each slide to receive focus.
        mediaQuery: 'min',
        breakpoints: {
          1: {
            perPage: 1,
            padding: '3em'
          },
          576: {
            perPage: 2
          },
          768: {
            perPage: 2,
          },
          992: {
            perPage: 3,
          },
          1200: {
            perPage: 1,
          },
          1400: {
            perPage: 1,
            autoWidth: true
          }
        }
      }
    const splideModal = new Splide(SliderModalElement[0], splideDefaultOptionsModal)

    splide.sync( splideModal );
    splide.mount();
    splideModal.mount();

    let myModalEl = document.getElementsByClassName("modal--gallery");
    for (let i = 0; i < myModalEl.length; i++) {
      myModalEl[i].addEventListener('shown.bs.modal', function (event) {
        splideModal.refresh();
      });
    }

  }
}

///
// Gallery slider
///

const modalSplides = document.querySelectorAll('.splide-modalsss')
if (modalSplides.length) {
  for (let i = 0; i < modalSplides.length; i++) {
    var splideElement
    splideElement = modalSplides[i]
    const splideDefaultOptions =
      {
        type: 'loop',
        focus: 'center',
        autoplay: false,
        interval: 7000,
        pauseOnHover: false,
        arrows: false,
        perPage: 2,
        perMove: 1,
        gap: '1.5em',
        pagination: true,
        keyboard: false, // Splide listens to key events at the document level and moves ALL carousels when arrow keys are used. Since keyboard and screen reader users use these keys to operate the tabs, this creates a very unusual experience.
        slideFocus: false, // removes tabindex="0" from each slide wrapper, since we only want our links inside each slide to receive focus.
        mediaQuery: 'min',
        breakpoints: {
          1: {
            perPage: 1,
            padding: '3em'
          },
          576: {
            perPage: 2
          },
          768: {
            perPage: 2,
          },
          992: {
            perPage: 3,
          },
          1200: {
            perPage: 1,
          },
          1400: {
            perPage: 1,
            autoWidth: true
          }
        }
      }
    const splide = new Splide(splideElement, splideDefaultOptions)

    splide.mount()
  }
}

///
// Event-Listing: Filter + Load-More (nur im WP-Kontext mit window.pamEventsAjax)
///

document.querySelectorAll('[data-events-listing]').forEach((section) => {
  const ajax = typeof window !== 'undefined' ? window.pamEventsAjax : null
  if (!ajax) return

  const container = section.querySelector('[data-events-container]')
  const filter = section.querySelector('[data-events-filter]')
  const monthFilter = section.querySelector('[data-events-month-filter]')
  const loadMore = section.querySelector('[data-events-load-more]')
  const empty = section.querySelector('[data-events-empty]')
  const nonce = section.dataset.nonce
  const perPage = parseInt(section.dataset.itemsPerPage || '9', 10)
  const order = (section.dataset.order || 'ASC').toUpperCase()
  const generateFrom = section.dataset.generateFrom || 'all_upcoming'
  const sourceProject = section.dataset.sourceProject || ''
  const sourcePs = section.dataset.sourcePs || ''
  let currentCategory = ''
  let currentMonth = ''

  const fetchPage = (page, replace) => {
    const body = new URLSearchParams()
    body.set('action', ajax.action)
    body.set('nonce', nonce)
    body.set('paged', String(page))
    body.set('per_page', String(perPage))
    body.set('order', order)
    body.set('generate_from', generateFrom)
    if (sourceProject) body.set('source_project', sourceProject)
    if (sourcePs) body.set('source_program_series', sourcePs)
    if (currentCategory) body.set('category', currentCategory)
    if (currentMonth) body.set('month', currentMonth)

    return fetch(ajax.url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString()
    })
      .then((r) => r.json())
      .then((data) => {
        if (!data || typeof data.html !== 'string') return
        if (replace) {
          container.innerHTML = data.html
        } else {
          container.insertAdjacentHTML('beforeend', data.html)
        }
        if (loadMore) {
          if (data.has_more) {
            loadMore.dataset.page = String(data.page + 1)
            loadMore.style.display = ''
          } else {
            loadMore.style.display = 'none'
          }
        }
        if (empty && replace) {
          // Bei Filterwechsel (replace) Empty-Hinweis togglen.
          // 0 Treffer = Server meldet 0 Pages (data.total = max_num_pages der Query).
          if (data.total === 0) {
            empty.removeAttribute('hidden')
          } else {
            empty.setAttribute('hidden', '')
          }
        }
      })
      .catch(() => { /* silent */ })
  }

  let filterTimer = null
  const triggerFilter = () => {
    if (filterTimer) clearTimeout(filterTimer)
    filterTimer = setTimeout(() => fetchPage(1, true), 200)
  }
  if (filter) {
    filter.addEventListener('change', () => {
      currentCategory = filter.value || ''
      triggerFilter()
    })
  }
  if (monthFilter) {
    monthFilter.addEventListener('change', () => {
      currentMonth = monthFilter.value || ''
      triggerFilter()
    })
  }
  if (loadMore) {
    loadMore.addEventListener('click', () => {
      const next = parseInt(loadMore.dataset.page || '2', 10)
      fetchPage(next, false)
    })
  }
})
